import { url } from '@/data/pages'

const twitterText = {
	art: '',
	business:
		'Оставьте%20свой%20мейл%20и%20получайте%20программы%20Михаила%20Перегудова,%20которые%20помогут%20стать%20более%20успешным%20в%20бизнесе.',
	career: 'Оставьте%20свой%20мейл%20и%20получайте%20программы%20по%20развитию%20карьеры%20от%20Алены%20Владимирской.',
	family:
		'Оставьте%20свой%20мейл%20и%20получайте%20программы%20от%20Ларисы%20Сурковой,%20которые%20помогут%20укрепить%20отношения%20в%20семье.',
	sport:
		'Оставьте%20свой%20мейл%20и%20получайте%20программы%20от%20Максима%20Журило,%20которые%20помогут%20прокачать%20свою%20спортивную%20форму.',
}

export default {
	computed: {
		shareVk() {
			return `https://vk.com/share.php?url=${url}/${this.route}`
		},
		shareFb() {
			return `https://www.facebook.com/dialog/share?app_id=1458967624164016&display=popup&href=${url}/${
				this.route
			}`
		},
		shareTw() {
			return `https://twitter.com/intent/tweet?url=${url}/${this.route}&text=${twitterText[this.route || 0]}`
		},
		route() {
			if (this.$route.name === 'main') return ''
			return this.$route.name
		},
	},
	methods: {
		shareClick(soc) {
			ga('send', 'event', 'share', this.$route.name, soc)
		},
		linkClick(url) {
			ga('send', 'event', 'link', this.$route.name, url)
		},
	},
}
